import React from "react";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { GreyCard, GreyCardProps } from "../../components/GreyCard";
import { GroupedComponents } from "../../components/GroupedComponents";
import { LinkButtonProps } from "../../components/LinkButton";
import { Links, LinksProps } from "../../components/Links";
import { List } from "../../components/List";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { ProcessSteps, ProcessStepsProps } from "../../components/ProcessSteps";
import { Responsibilities, ResponsibilitiesProps } from "../../components/Responsibilities";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { GenericListProps } from "../../types/GenericListType";

export interface GasOutagesPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  lists?: GenericListProps[];
  processes?: ProcessStepsProps[];
  applyButton?: LinkButtonProps;
  faqs?: FaqAccordionGroupProps;
  wantToReport?: GreyCardProps;
  linksList?: LinksProps[];
  responsibilities?: ResponsibilitiesProps[];
}

export const GasOutagesPage: React.FC<GasOutagesPageProps> = ({
  seo,
  pageTitle,
  paragraphs,
  lists,
  processes,
  faqs,
  wantToReport,
  linksList,
  responsibilities,
}) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      <GroupedComponents>
        {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
        {lists && lists[0] && <List {...lists[0]} />}
        {paragraphs && paragraphs[1] && <Paragraph {...paragraphs[1]} />}
        {lists && lists[1] && <List {...lists[1]} />}
      </GroupedComponents>
      {responsibilities && responsibilities[0] && <Responsibilities {...responsibilities[0]} />}
      {processes && processes[0] && <ProcessSteps {...processes[0]} />}
      {processes && processes[1] && <ProcessSteps {...processes[1]} />}
      {wantToReport && <GreyCard {...wantToReport} />}
      {linksList && linksList[0] && <Links {...linksList[0]} />}
    </ServiceCataloguePageWrapper>
  );
};
